export const STATUS_META = {
  actif_conforme: { label: 'Actif – Conforme', cls: 'bg-green-100 text-green-700 border-green-300' },
  actif_a_surveiller: { label: 'Actif – À surveiller', cls: 'bg-yellow-100 text-yellow-700 border-yellow-300' },
  immobilise: { label: 'Immobilisé', cls: 'bg-red-100 text-red-700 border-red-300' },
  en_reparation: { label: 'En réparation', cls: 'bg-orange-100 text-orange-700 border-orange-300' },
  inactif: { label: 'Inactif', cls: 'bg-gray-200 text-gray-600 border-gray-300' },
  archive: { label: 'Archivé', cls: 'bg-gray-300 text-gray-500 border-gray-400' },
  attente_decision_securite: { label: 'En attente de décision sécurité', cls: 'bg-purple-100 text-purple-700 border-purple-300' },
};

export const CONTROL_META = {
  realise: { label: 'Réalisé cette semaine', cls: 'bg-green-100 text-green-700' },
  a_faire: { label: 'À faire cette semaine', cls: 'bg-blue-100 text-blue-700' },
  en_retard: { label: 'Contrôle en retard', cls: 'bg-red-100 text-red-700' },
};

export const ITEM_STATES = [
  { value: 'conforme', label: 'Conforme', cls: 'bg-green-600 text-white' },
  { value: 'a_surveiller', label: 'À surveiller', cls: 'bg-yellow-500 text-white' },
  { value: 'defectueux', label: 'Défectueux', cls: 'bg-orange-600 text-white' },
  { value: 'bloquant', label: 'Bloquant', cls: 'bg-red-600 text-white' },
  { value: 'non_controle', label: 'Non contrôlé', cls: 'bg-gray-400 text-white' },
  { value: 'non_applicable', label: 'N/A', cls: 'bg-gray-300 text-gray-700' },
];

export const ISSUE_STATUS_META = {
  signalee: { label: 'Signalée', cls: 'bg-red-100 text-red-700' },
  prise_en_charge: { label: 'Prise en charge', cls: 'bg-blue-100 text-blue-700' },
  planifiee: { label: 'Planifiée', cls: 'bg-indigo-100 text-indigo-700' },
  en_reparation: { label: 'En réparation', cls: 'bg-orange-100 text-orange-700' },
  reparee: { label: 'Réparée', cls: 'bg-green-100 text-green-700' },
  non_averee: { label: 'Non avérée', cls: 'bg-gray-200 text-gray-600' },
  non_reparable: { label: 'Non réparable', cls: 'bg-gray-300 text-gray-700' },
};

export const SEVERITY_META = {
  a_surveiller: { label: 'À surveiller', cls: 'bg-yellow-100 text-yellow-700' },
  defectueux: { label: 'Défectueux', cls: 'bg-orange-100 text-orange-700' },
  a_corriger_avant_depart: { label: 'À corriger avant départ', cls: 'bg-orange-600 text-white' },
  bloquant: { label: 'BLOQUANT', cls: 'bg-red-600 text-white' },
};

export const DAILY_CATEGORIES = [
  { key: 'pneus', label: 'Pneus (état et pression visuelle)' },
  { key: 'feux', label: 'Feux et clignotants' },
  { key: 'pare_brise', label: 'Pare-brise et essuie-glaces' },
  { key: 'freins_direction', label: 'Freins et direction (comportement)' },
  { key: 'voyants_bruits', label: 'Voyants et bruits anormaux' },
  { key: 'fuites', label: 'Fuites visibles' },
  { key: 'portes_chargement', label: 'Portes et zone de chargement' },
  { key: 'equipements_securite', label: 'Équipements de sécurité' },
  { key: 'dommages_exterieurs', label: 'Dommages extérieurs' },
  { key: 'km_proprete', label: 'Kilométrage et propreté' },
];

export const DAILY_ITEM_STATES = [
  { value: 'conforme', label: 'Conforme', cls: 'bg-green-600 text-white' },
  { value: 'probleme', label: 'Problème', cls: 'bg-red-600 text-white' },
  { value: 'non_controle', label: 'Non contrôlé', cls: 'bg-gray-400 text-white' },
  { value: 'na', label: 'N.A.', cls: 'bg-gray-300 text-gray-700' },
];

export const DAILY_OUTCOME_META = {
  conforme: { label: 'Conforme', cls: 'bg-green-100 text-green-700' },
  a_surveiller: { label: 'Problème non bloquant', cls: 'bg-yellow-100 text-yellow-700' },
  a_corriger: { label: 'À corriger avant départ (départ refusé, sans immobilisation)', cls: 'bg-orange-100 text-orange-800' },
  attente_decision: { label: 'En attente de décision sécurité', cls: 'bg-purple-100 text-purple-700' },
};

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.actif_conforme;
  return <span className={`text-xs px-2 py-1 rounded-full border font-bold ${meta.cls}`} data-testid={`vehicle-status-${status}`}>{meta.label}</span>;
};

export const fmtDate = (iso) => iso ? new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
